import { forwardRef } from 'react';

import Box from '@mui/material/Box';
import { blue, green, grey, red, orange, yellow } from '@mui/material/colors';
import PropTypes from 'prop-types';

import Text from '../../elements/text/Text';

const StatusCaption = forwardRef(
  ({ icon: IconComponent, text, color, ...restProps }, ref) => {
    // These are the accepted colors. Feel free to expand if necessary.
    const captionColor = () => {
      switch (color) {
        case 'red':
          return red[500];
        case 'orange':
          return orange[700];
        case 'yellow':
          return yellow[800];
        case 'green':
          return green[500];
        case 'blue':
          return blue[500];
        case 'grey':
          return grey[700];
        default:
      }
    };

    return (
      <Box
        ref={ref}
        sx={{ display: 'flex', alignItems: 'center' }}
        {...restProps}
      >
        <IconComponent
          sx={{ fontSize: '0.8em', padding: '2px' }}
          style={{ color: captionColor(color) }}
        />
        <Text variant="caption" style={{ color: captionColor(color) }}>
          {text}
        </Text>
      </Box>
    );
  }
);

StatusCaption.displayName = 'StatusCaption';

StatusCaption.propTypes = {
  icon: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
};

export default StatusCaption;
